"use client";
import React from "react";
import "@/app/impressum/Impressum.css";
import Link from "next/link";
import StickyWidget from "@/common/StickyWidget/StickyWidget";
import { getSupportEmail } from "@/lib/envConfig";

function Kontakt() {
  const supportEmail = getSupportEmail();

  return (
    <div className="Presse-main-wrapper">
      <div className="Presse">
        <div className="Presse-wrapper">
          <nav className="Presse-nav">
            <Link href="/" className="transition">
              Startseite
            </Link>
          </nav>

          <div className="Presse-main">
            <div className="Presse-left">
              <h1>Kontaktiere uns</h1>
              <p>
                Wir sind für dich da. Zögere nicht, uns zu kontaktieren, wenn du
                Verkaufsberatung, Informationen zu Fahrzeugdetails, Fragen zum
                Prozess oder andere Anliegen hast.
              </p>

              <h2>Kundendienst</h2>

              <p>
                Wenn du dich bereits angemeldet hast, um dein Auto zu verkaufen,
                und Fragen zur Profilierung deines Fahrzeugs hast, kannst du
                unser Kundendienstteam unter
                <strong> {supportEmail} </strong>
                kontaktieren oder uns unter <strong>
                  {" "}
                  +43 720 881056
                </strong>{" "}
                anrufen. Bitte gib in allen E-Mails deinen Namen und das
                Kennzeichen deines Fahrzeugs an.
              </p>

              <p>Unser Kundendienstteam ist erreichbar:</p>
              <ul className="AV-Fragen-ul">
                <li>Montag bis Freitag: 9:00–18:30 Uhr</li>
                <li>Samstag: 9:00–17:00 Uhr</li>
                <li>Sonntag: 10:00–17:00 Uhr</li>
              </ul>
            </div>

            <div className="Presse-right">
              <StickyWidget />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Kontakt;
